export default __webpack_public_path__ + "static/Corprate_Careers-DC_11-e5b12b8f9bed1b185d3c9ffd686733ae.jpg";